"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportingFilterPresets = exports.deleteReportingFilterPreset = exports.updateReportingFilterPreset = exports.createReportingFilterPreset = exports.getReportingFilterPreset = exports.getReportingFilterPresets = void 0;
/**
 * TODO: remove this method after this ticket https://abtasty.atlassian.net/browse/TI-1720
 *   is done
 *
 */
const prepareBelongsToData = (defaultFilterPresets) => {
    if (!defaultFilterPresets) {
        return [];
    }
    return Object.entries(defaultFilterPresets).reduce((resultValue, [groupName, campaignIds]) => {
        return [
            ...resultValue,
            ...campaignIds.map((campaignId) => ({
                id: campaignId,
                group: groupName,
            })),
        ];
    }, []);
};
const getReportingFilterPresets = (caller) => async ({ accountId }) => {
    const filterPresets = (await caller(`/accounts/${accountId}/reporting-filter-presets`).get()) || [];
    return filterPresets.map((filterPreset) => {
        const { default_filter_presets, ...restFilterPreset } = filterPreset;
        return {
            ...restFilterPreset,
            belongs_to: prepareBelongsToData(default_filter_presets),
        };
    });
};
exports.getReportingFilterPresets = getReportingFilterPresets;
const getReportingFilterPreset = (caller) => async ({ accountId, presetId }) => {
    const filterPreset = await caller(`/accounts/${accountId}/reporting-filter-presets/${presetId}`).get();
    return {
        ...filterPreset,
        belongs_to: prepareBelongsToData(filterPreset.default_filter_presets),
    };
};
exports.getReportingFilterPreset = getReportingFilterPreset;
const createReportingFilterPreset = (caller) => ({ accountId, data }) => {
    return caller(`/accounts/${accountId}/reporting-filter-presets`).post(data, { withResponse: true });
};
exports.createReportingFilterPreset = createReportingFilterPreset;
const updateReportingFilterPreset = (caller) => ({ accountId, filtersId, data }) => {
    return caller(`/accounts/${accountId}/reporting-filter-presets/${filtersId}`).patch(data);
};
exports.updateReportingFilterPreset = updateReportingFilterPreset;
const deleteReportingFilterPreset = (caller) => ({ accountId, filtersId }) => {
    return caller(`/accounts/${accountId}/reporting-filter-presets/${filtersId}`).delete();
};
exports.deleteReportingFilterPreset = deleteReportingFilterPreset;
const reportingFilterPresets = (caller) => {
    return {
        get: (0, exports.getReportingFilterPresets)(caller),
        getOne: (0, exports.getReportingFilterPreset)(caller),
        create: (0, exports.createReportingFilterPreset)(caller),
        update: (0, exports.updateReportingFilterPreset)(caller),
        delete: (0, exports.deleteReportingFilterPreset)(caller),
    };
};
exports.reportingFilterPresets = reportingFilterPresets;
//# sourceMappingURL=api.js.map